var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "div",
    { staticClass: "w100" },
    [
      _c("w-breadcrumb", { attrs: { crumbs: _vm.path } }),
      _c(
        "w-container",
        [
          _c(
            "w-row",
            [
              _c(
                "w-col",
                { attrs: { xs: "12", md: "6" } },
                [_c("app-api-keys")],
                1
              ),
              _c(
                "w-col",
                { attrs: { xs: "12", md: "6" } },
                [_c("app-wf-online-api-keys")],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }